import { Typography } from '@mui/material';
import React from 'react';
import {
  Create,
  CreateBase,
  CreateProps,
  DateInput,
  Labeled,
  SimpleForm,
  TextInput,
  useTranslate,
} from 'react-admin';
import { LinesInput } from '../contracts/lines/LinesInput';
import { SubTotalField } from '../contracts/SubTotalField';
import { CreditMemo } from '../types';
import CreditMemoCreateOrEditToolbar from './CreditMemoCreateOrEditToolbar';

const validateLinesExist = (values:any) => {
  const errors: {[k: string]: any} = {};
  if(values.lines === undefined || values.lines.length === 0){
    errors.lines = 'You must have at least one item';
  }

  return errors;

}

interface Props extends CreateProps<CreditMemo> {
  onCancel: () => void;
}

export const CreditMemoCreate = ({ onCancel, ...props }: Props) => {
  const translate = useTranslate();
  return (
    <CreateBase {...props}>
      <SimpleForm toolbar={<CreditMemoCreateOrEditToolbar />}>
       </SimpleForm>
    </CreateBase>
  );
};
